import { G2FSSContainer } from 'components/common/styled';
import styled from 'styled-components';

export const LandingContainer = styled(G2FSSContainer)``;

export const LandingHeadingContainer = styled(G2FSSContainer)`
    margin-bottom: 24px;
`;